<div class="notfall">
  <!-- ─── Hero ─────────────────────────────────────────────── -->
  <section class="notfall__hero">
    <div class="notfall__container notfall__hero-inner">
      <!-- Eyebrow: bewusst KEIN „LIVE"-Claim hier — die echte Live-Verfügbarkeit
           hängt an der PLZ und wird erst auf der Detail-Seite geprüft. Hier nur
           die wahre Capability-Aussage (rund um die Uhr, Festpreis). -->
      <span class="notfall__eyebrow">
        <span class="notfall__eyebrow-dot" aria-hidden="true"></span>
        24/7 · Alarm-Netz · Festpreis
      </span>

      <div class="notfall__hero-emblem" aria-hidden="true">
        <svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="currentColor"
             stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
          <path d="M13 2 4 14h7l-1 8 9-12h-7l1-8Z" />
        </svg>
      </div>

      <h1 class="notfall__hero-title">
        <span class="notfall__hero-title-1">Notfall.</span>
        <span class="notfall__hero-title-2">Sofort.</span>
      </h1>
      <p class="notfall__hero-sub">
        Rohrbruch, Stromausfall, ausgesperrt? Wähle deine Kategorie — ein Betrieb
        aus dem Alarm-Netz prüft sofort die Verfügbarkeit in deiner PLZ. Fester
        Preis pro Notfall, kein Aufschlag-Modell, kein böses Erwachen.
      </p>
    </div>
  </section>

  <!-- ─── Kategorien-Grid ──────────────────────────────────── -->
  <section class="notfall__section">
    <div class="notfall__container">
      @if (loading()) {
        <div class="notfall__skeleton-grid" aria-hidden="true">
          <div class="notfall__skeleton-card"></div>
          <div class="notfall__skeleton-card"></div>
          <div class="notfall__skeleton-card"></div>
          <div class="notfall__skeleton-card"></div>
          <div class="notfall__skeleton-card"></div>
          <div class="notfall__skeleton-card"></div>
        </div>
      } @else if (errorMessage()) {
        <div class="notfall__error" role="alert">
          {{ errorMessage() }}
        </div>
      } @else if (sortedKategorien().length === 0) {
        <!-- Empty-State: kein Alarm-Netz-Eintrag — ehrlicher Ausweg statt leerer Seite -->
        <div class="notfall__empty">
          <p class="notfall__empty-title">Aktuell keine Notfall-Kategorie verfügbar.</p>
          <p class="notfall__empty-text">
            Stelle stattdessen eine reguläre Anfrage — verifizierte Betriebe in
            deiner Nähe melden sich werktags innerhalb von 24&nbsp;Stunden.
          </p>
          <a routerLink="/anfrage/neu" class="notfall__empty-cta">Reguläre Anfrage stellen →</a>
        </div>
      } @else {
        <div class="notfall__grid-head">
          <span class="notfall__grid-label">Notfall wählen</span>
          <span class="notfall__grid-hint">Festpreise inkl. USt · aktueller Zeit-Slot</span>
        </div>
        <div class="notfall__grid">
          @for (kat of sortedKategorien(); track kat.slug) {
            <button
              type="button"
              class="notfall__card"
              (click)="goToKategorie(kat.slug)"
              [attr.aria-label]="kat.bezeichnung + ' — Festpreis ab ' + kat.aktuellerFestpreis + ' Euro inklusive Umsatzsteuer'">
              <div class="notfall__card-icon">
                <i class="pi" [class]="'pi ' + kat.iconKey"></i>
              </div>
              <div class="notfall__card-body">
                <span class="notfall__card-title">{{ kat.bezeichnung }}</span>
                <span class="notfall__card-price">
                  Festpreis {{ kat.aktuellerFestpreis | currency:'EUR':'symbol':'1.0-0':'de' }}
                  <span class="notfall__card-tax">inkl.&nbsp;USt</span>
                </span>
                <span class="notfall__card-slot">aktueller Slot: {{ kat.aktuellesZeitfenster }}</span>
              </div>
              <span class="notfall__card-arrow" aria-hidden="true">→</span>
            </button>
          }
        </div>

        <!-- ─── „Kein Notfall?" — gleichberechtigter Ausweg (Compliance § 6.6) +
                 Modell-Abgrenzung in einem Satz (C9) ─────────────────────── -->
        <div class="notfall__alt">
          <p class="notfall__alt-line">
            <strong>Notfall</strong> = ein fester Sofort-Preis, ein Betrieb kommt direkt.
            <strong>Reguläre Anfrage</strong> = du vergleichst in Ruhe bis zu fünf Angebote.
          </p>
          <p class="notfall__alt-cta">
            Kein Notfall, sondern eine planbare Aufgabe?
            <a routerLink="/anfrage/neu">Stelle eine reguläre Anfrage →</a>
          </p>
        </div>
      }
    </div>
  </section>

  <!-- ─── Sicherheit zuerst — MUSS bleiben (Spec A) ────────── -->
  <section class="notfall__section notfall__section--tight">
    <div class="notfall__container">
      <div class="notfall__safety">
        <span class="notfall__safety-head">Sicherheit zuerst</span>
        <div class="notfall__safety-row">
          <span class="notfall__safety-badge">Lebensgefahr / Feuer</span>
          <span class="notfall__safety-text">
            Wir sind kein Rettungsdienst. Bei Lebensgefahr, Feuer oder akuter
            medizinischer Notlage: <strong>112</strong>.
          </span>
        </div>
        <div class="notfall__safety-row">
          <span class="notfall__safety-badge">Strom-/Gasleitung</span>
          <span class="notfall__safety-text">
            Bei beschädigter Strom- oder Gasleitung: zuerst den
            <strong>Netzbetreiber</strong> informieren bzw. <strong>112</strong>.
            Der Handwerker kann erst tätig werden, sobald die Leitung gesichert ist.
          </span>
        </div>
        <div class="notfall__safety-row">
          <span class="notfall__safety-badge">Ärztl. Notdienst</span>
          <span class="notfall__safety-text">
            Bei medizinischen Anliegen ohne Lebensgefahr: <strong>116 117</strong>.
          </span>
        </div>
      </div>
    </div>
  </section>
</div>
